import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

enum AppointmentType {
	CORPORATE = 'CORPORATE',
	PARTICULAR = 'PARTICULAR',
}

@Component({
	selector: 'appointment-type-badge',
	templateUrl: 'appointment-type-badge.component.html',
	styleUrls: ['appointment-type-badge.component.scss'],
})
export class AppointmentTypeBadgeComponent implements OnChanges {
	@Input() subscriptionType: string | null;
	@Input() iconOnly: boolean;
	@Input() textOnly: boolean;
	showIcon = true;
	showText = true;
	showBadge = true;
	color: string;
	icon: string;
	text: string;
	appointmentType: AppointmentType;

	constructor(private readonly translateService: TranslateService) {}

	ngOnChanges(changes: SimpleChanges) {
		if (changes.subscriptionType) {
			this.setViewType();
			this.setAppointmentType();
			this.setColor();
			this.setText();
			this.setIcon();
		}
	}

	setViewType() {
		if (this.iconOnly) {
			this.showIcon = true;
			this.showBadge = true;
			this.showText = false;
			return;
		}

		if (this.textOnly) {
			this.showIcon = false;
			this.showBadge = false;
			this.showText = true;
			return;
		}

		this.showIcon = true;
		this.showBadge = true;
		this.showText = true;
	}

	setAppointmentType() {
		if (this.subscriptionType === 'corporate_subscription') {
			this.appointmentType = AppointmentType.CORPORATE;
		} else {
			this.appointmentType = AppointmentType.PARTICULAR;
		}
	}

	setColor() {
		switch (this.appointmentType) {
			case AppointmentType.CORPORATE:
				this.color = 'badge-corporate';
				break;

			case AppointmentType.PARTICULAR:
				this.color = 'badge-particular';
				break;

			default:
				this.color = '';
				break;
		}
	}

	setText() {
		switch (this.appointmentType) {
			case AppointmentType.CORPORATE:
				this.text =
					this.showText && !this.showIcon && !this.showBadge
						? this.translateService.instant('GENERAL.CORPORATE')
						: this.translateService.instant('GENERAL.CORPORATE_APPOINTMENT');
				break;

			case AppointmentType.PARTICULAR:
				this.text =
					this.showText && !this.showIcon && !this.showBadge
						? this.translateService.instant('GENERAL.PARTICULAR')
						: this.translateService.instant('GENERAL.PARTICULAR_APPOINTMENT');
				break;

			default:
				this.text = '';
				break;
		}
	}

	setIcon() {
		switch (this.appointmentType) {
			case AppointmentType.CORPORATE:
				this.icon = 'freud-icon-briefcase';
				break;

			case AppointmentType.PARTICULAR:
				this.icon = 'freud-icon-user';
				break;

			default:
				this.icon = '';
				break;
		}
	}

	get badgeClasses() {
		return {
			badge: this.showBadge,
			[this.color]: this.showBadge,
		};
	}
}
